/**
 * Persistent warning banner shown while impersonating another user.
 */

import { useState } from 'react';
import { UserCog } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui';
import {
  endImpersonation,
  getImpersonationTargetEmail,
} from '@/features/auth/services/impersonation.service';

export function ImpersonationBanner() {
  const [busy, setBusy] = useState(false);
  const { t } = useTranslation('nav');
  const targetEmail = getImpersonationTargetEmail();
  if (!targetEmail) return null;

  const onReturn = async () => {
    setBusy(true);
    await endImpersonation();
  };

  return (
    <div
      role="status"
      className="flex items-center justify-between gap-3 border-b border-warning-foreground/15 bg-warning px-4 py-2 text-sm font-medium text-warning-foreground"
    >
      <span className="flex items-center gap-2">
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-warning-foreground/10">
          <UserCog className="h-4 w-4" aria-hidden="true" />
        </span>
        {t('impersonation.viewingAs', { email: targetEmail })}
      </span>
      <Button
        size="sm"
        variant="outline"
        onClick={onReturn}
        loading={busy}
        aria-label={t('impersonation.returnAria')}
      >
        {t('impersonation.returnToAdmin')}
      </Button>
    </div>
  );
}
